const Ajv = require("ajv");
const addFormats = require("ajv-formats");

const ajv = new Ajv({
  strict: false,
  allErrors: true,
  strictRequired: true,
  allowDate: true,
  loopEnum: 60,
  loopRequired: 60,
  ownProperties: true,
  verbose: true // dony set
});
addFormats(ajv);

const schemaViki = {
  type: "array",
  minItems: 1,
  items: {
    type: "object",
    properties: {
      name: {
        type: "string",
        minLength: 3
      },
      type: {
        type: "string",
        minLength: 3,
        enum: ["input", "date", "choice", "boolean", "photo", "geo", "label", "video", "viewer", "datasource"],
        errorMessage: 'Este tipo de pregunta no es válida para el subformulario.',
        pathI18n: `FORMS`
      },
      label: {
        type: "string",
        minLength: 3
      },
      required: {
        type: "boolean"
      },
      help: {
        type: "string",
        minLength: 3
      },
      inputType: {
        type: "string",
        minLength: 3,
        enum: [
          "default",
          "email",
          "barcode",
          "phone",
          "textarea",
          "ranking",
          "number",
          "currency",
          "domain",
          "QRReader",
          "calendar",
          "multi",
          "radio",
          "standar",
          "camera",
          "gallery",
          "gallery/camera",
          "servi",
          "location",
          "label",
          "paragraph",
          "url",
          "web",
          "document",
          "flex",
          "scala",
          "QRGen",
          "ipv4",
          "ipv6",
          "multiInput",
          "checktext",
          "unixtime",
          "multiOther",
          "radioOther"

        ]
      },
      maxLength: {
        type: "number",
        minimum: 1
      },
      properties: {
        type: "object",
        properties: {
          min: { type: "number" },
          max: { type: "number" },
          default: { type: "string" },
          size: { type: "number" },
          color: { type: "string" },
          orientation: { type: "string" },
          minValue: { type: "number" },
          maxValue: { type: "number" }
        },
        additionalProperties: false
      },
      options: {
        type: "array",
        minItems: 1,
        items: {
          type: "string",
          minLength: 2
        }
      },
      content: {
        type: "string",
        minLength: 3
      },
      related: {
        type: "object",
        properties: {
          answer: {
            type: "string",
            minLength: 3
          },
          answers: {
            type: "array",
            items: [{ type: "integer" }, { type: "string" }, { type: "boolean" }]
          },
          name: {
            type: "string",
            minLength: 3
          },
          question: {
            type: "number",
            minimum: 0
          },
          relatedness: {
            type: "string",
            minLength: 3,
            enum: ["simple", "compound"]
          },
          type: {
            type: "string",
            minLength: 3
          }
        },
        required: ["name", "question", "relatedness"],
        additionalProperties: false
      }
    },
    errorMessage: "La estructura del subformulario tiene propiedades adicionales",
    additionalProperties: false,
    required: ["name", "type", "label", "required", "inputType"]
  }
};

export const validationViki = (json) => {
    const validate = ajv.compile(schemaViki);
    const valid = validate(json);
    // if (!valid) console.log(validate.errors)
    return { valid, error: validate.errors };
};
